export default __webpack_public_path__ + "static/media/house-concept.2e1fa959.jpg";